// Familias de producto — FUENTE ÚNICA (espejo de la tabla `producto`).
//
// Generada de un `SELECT DISTINCT familia FROM producto` sobre la base de
// producción el 30-07-2026. NO es una lista inventada ni heredada del código
// viejo: se comprobó entrada por entrada contra la base.
//
// Contexto: esta lista estaba duplicada a mano en tres sitios con contenidos
// distintos —AddProduct.js (167), UpdateProducts.js (28) y el backend en
// routes/AddProduct.js (34)—. Desde "Gestión de Productos" no se podía asignar
// el 82 % de las familias reales, y un producto que ya estuviera en una de las
// que faltaban se mostraba como "Sin familia", porque un <select> cae a su
// primera <option> cuando su value no coincide con ninguna. Se veía mal estando
// bien en la base, lo que invitaba a "corregirlo" y machacar el dato.
//
// La lista de AddProduct.js tenía 167 entradas y la base 166: coincidían casi en
// número pero NO en contenido. Le faltaban FARMACIA, FÁRMACOS y RELAJANTES
// MUSCULARES (reales, con productos dentro) y sobraban 4 que no existen.
//
// 'Sin familia' se excluye a propósito: no es una familia, es la etiqueta del
// desplegable que acabó escribiéndose literalmente en la columna.
//
// Esto es solo el SUELO MÍNIMO. En caliente se une con las familias de los
// productos cargados y con /api/productos/familias, que es la fuente viva.
// Al añadir una familia nueva basta con asignarla a un producto.
export const FAMILIAS_PREDEFINIDAS = [
  'ABSORBENTES',
  'ACCESORIOS',
  'ACCESORIOS INSTRUMENTAL',
  'ACCESORIOS PARA CURAS',
  'ACCESORIOS PUNCION E INCISION',
  'ACCESORIOS RECOGIDA RESIDUOS',
  'ACCESORIOS REGISTRO DE DATOS',
  'ACCESORIOS SUTURAS',
  'AGUJAS CONVENCIONALES',
  'AGUJAS ESPECIALES',
  'ALARGADERAS',
  'ALCOHOLES',
  'ALGODÓN',
  'ANESTÉSICOS GENERALES',
  'ANTAGONISTAS DE LA SEROTONINA',
  'ANTIANÉMICOS',
  'ANTIASMITICOS: AGONISTAS ALFA Y BETA-ADRENÉRGICOS',
  'ANTICONVULSIVOS',
  'ANTIEPILEPTICOS',
  'ANTIMICÓTICOS',
  'ANTISÉPTICOS Y DESINFECTANTES',
  'ANTIVIRALES DE ACCION DIRECTA',
  'APÓSITOS',
  'APÓSITOS CONVENCIONALES',
  'BATAS, GORROS, CALZAS, MASCARILLAS',
  'BETA-LACTAMAS',
  'BISFOSFONATOS',
  'BOBINAS',
  'BOLSAS COLECTORAS',
  'BOLSAS DE ASPIRACIÓN',
  'BOLSAS DE ORINA',
  'BOLSAS MIXTAS',
  'BRAGAPAÑALES ADULTO',
  'BULBOS DE SILICONA',
  'CAL',
  'CANULAS, TROCARES Y CATETERES',
  'CATETERES',
  'CATÉTERES ESPECIALES',
  'CATÉTERES PERIFÉRICOS',
  'CATÉTERES VENOSOS CENTRALES',
  'CEFALOSPORINAS Y SIMILARES',
  'CEPILLOS',
  'CEPILLOS QUIRÚRGICOS',
  'CIRCUITOS RESPIRACION',
  'COMPRESA DE GASA',
  'COMPRESAS QUIRÚRGICAS',
  'CONECTORES MÚLTIPLES',
  'CONTENEDORES DE ORINA ASÉPTICOS',
  'CONTENEDORES MUESTRAS',
  'CONTENEDORES RESIDUOS',
  'CONTROLES DE ESTERILIZACIÓN POR OXIDO DE ETILENO',
  'CONTROLES DE ESTERILIZACIÓN POR VAPOR',
  'CONTROLES ESTERILIZACIÓN POR FORMALDEHIDO',
  'CONTROLES ESTERILIZACIÓN POR ÁCIDO PERACÉTICO',
  'CUCHILLETES OFTALMICOS',
  'CÁNULA GUEDEL',
  'CÁNULAS',
  'CÁNULAS ESPECIALES',
  'CÁNULAS YANKAUER',
  'DEPRESORES LINGUALES',
  'DESINFECTANTES',
  'DIURÉTICOS',
  'DRENAJES',
  'ELECTROBISTURIES Y ACCESORIOS',
  'ELECTRODOS CONVENCIONALES',
  'ELECTRODOS ESPECIALES',
  'EMPAPADORES',
  'EQUIPOS',
  'EQUIPOS DE INFUSIÓN E IRRIGACIÓN',
  'EQUIPOS DE PUNCIÓN E INCISIÓN',
  'EQUIPOS DE SEGURIDAD PARA CITOSTÁTICOS',
  'EQUIPOS DE TRACCIÓN',
  'EQUIPOS DE TRANSFUSIÓN',
  'ESPARADRAPOS',
  'ESPÉCULOS',
  'FARMACIA',
  'FARMACIA4',
  'FILTROS',
  'FUNDAS ESTÉRILES',
  'FUNDAS PROTECCION',
  'FÁRMACOS',
  'GAFAS NASALES',
  'GUANTES',
  'GUANTES ESTÉRILES DE EXAMEN',
  'GUANTES NO ESTÉRILES',
  'GUANTES QUIRÚRGICOS',
  'GUÍAS DE INTUBACIÓN',
  'HOJAS DE BISTURÍ',
  'HUMIDIFICADORES',
  'INDICADORES',
  'INFORMATICA',
  'INFUSIÓN E IRRIGACION',
  'INMOVILIZADORES',
  'INSPIRÓMETROS DE ESTIMULACIÓN',
  'JERINGAS',
  'KITS',
  'LENTINAS QUIRÚRGICAS',
  'LIMPIEZA',
  'LOCIONES LIMPIADORAS Y CREMAS PROTECTORAS',
  'LUBRICANTES',
  'MACRÓLIDOS',
  'MASCARILLA LARÍNGEAS Y REANIMADORES',
  'MASCARILLAS OXIGENO Y NEBULIZACIÓN',
  'MASCARILLAS, NEBULIZADORES Y GAFAS',
  'MATERIAL AUXILIAR',
  'MATERIAL DE GINECOLOGÍA',
  'MATERIAL DE LAPAROSCOPIA',
  'MATERIAL SANITARIO',
  'MEDIAS DE CONTENCION',
  'OFICINA',
  'OTRO INSTRUMENTAL',
  'OTROS ANALGÉSICOS Y ANTIPIRÉTICOS',
  'OTROS ANTIBACTERIANOS',
  'OTROS MATERIALES HIGIENE Y PROTECCIÓN',
  'PALOMILLAS DE EXTRACCIÓN',
  'PAPEL',
  'PAPEL REGISTRO DATOS',
  'PAÑOS Y SÁBANAS',
  'PINZAS RETIRADA GRAPAS',
  'PROPOFOL',
  'PROTECTORES',
  'PUNCH BIOPSIA',
  'PUNZONES BIOPSIA',
  'QUINOLONAS',
  'RASURADORAS',
  'REACTIVOS Y OTROS',
  'REGULADORES, LLAVES Y TAPONES',
  'REGULADORES,LLAVES Y TAPONES',
  'RELAJANTES MUSCULARES',
  'RESERVORIOS BAJO VACIO',
  'RESUCITADORES',
  'ROLLOS DE PAPEL',
  'ROTULADORES QUIRÓFANO',
  'SENSORES ANÁLISIS BIESPECTRAL',
  'SENSORES DE OXIGENO',
  'SETS QUIRÚRGICOS',
  'SISTEMAS DE RECOGIDA',
  'SOLUCIONES',
  'SONDAS DE ASPIRACIÓN',
  'SONDAS FOLEY 2 VÍAS PUNTA TIEMANN',
  'SONDAS NASOGASTRICAS',
  'SONDAS PARA REDÓN',
  'SONDAS TIEMANN',
  'SONDAS VESICALES FOLEY',
  'SONDAS VESICALES NELATON',
  'SUEROS',
  'SUTURAS CUTÁNEAS',
  'SUTURAS DE NYLON',
  'SUTURAS DE POLIAMIDA',
  'SUTURAS DE POLIESTER',
  'SUTURAS DE POLIPROPILENO',
  'SUTURAS REABSORBIBLES',
  'TALLAS',
  'TERMÓMETROS',
  'TEST DROGAS',
  'TEST RÁPIDOS',
  'TIRAS DE CONTROL',
  'TRANSVASADORES',
  'TUBO ENDOTRAQUEAL C/BALON, ORAL/NASAL',
  'TUBOS PROLONGADORES PARA ASPIRACIÓN',
  'TUBOS Y CONECTORES',
  'UROSTOMÍA',
  'VARIOS',
  'VENDA DE ALGODÓN CREPÉ',
  'VENDAS',
  'VESTUARIO'
];
